function isAllNumbers(value) {
    var parts = value.split('');
    var isAllNumbers = parts.every(function (part, index) {
        if (part.trim() === '') {
            return false;
        }
        var invalid = isNaN(Number(part));
        if (index === 0 && part === '+' && invalid) {
            return true;
        }
        return !invalid;
    });
    return isAllNumbers;
}
export function isPhonenumber(value) {
    var valueFirst = value.trim()[0];
    if (valueFirst !== '0' && valueFirst !== '+') {
        return false;
    }
    if (value.trim().length < 7) {
        return false;
    }
    if (value.trim().length > 16) {
        return false;
    }
    if (!isAllNumbers(value.trim())) {
        return false;
    }
    return true;
}
